export default __webpack_public_path__ + "static/3-e0240225eb5feac6e4c66b0823285ee4.jpeg";